import { render, staticRenderFns } from "./tira.vue?vue&type=template&id=62652903&lang=html&"
import script from "./tira.vue?vue&type=script&lang=js&"
export * from "./tira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports